import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { MsImageViewerComponent } from './ms-image-viewer.component';

/**
 * Module riêng cho trình xem ảnh.
 *
 * Một component chỉ được khai báo trong đúng MỘT NgModule, mà trình xem ảnh
 * này dùng ở nhiều trang. Nên gói vào module riêng rồi trang nào cần thì
 * import module, thay vì mỗi trang tự khai báo component.
 */
@NgModule({
  imports: [CommonModule, IonicModule],
  declarations: [MsImageViewerComponent],
  exports: [MsImageViewerComponent],
})
export class MsImageViewerModule {}
